// pages/Edit.tsx
import React from 'react';
import { useForm } from 'react-hook-form';
import CrudEdit from '~/components/CrudEdit';
import IMaterial from '../interfaces/IMaterial';

export default function Edit() {
  const { register, handleSubmit, control, setValue: setFormValue, getValues } = useForm<IMaterial>();
  const fields = [
    { name: 'id', type: 'hidden' },
    { name: 'name', type: 'string' },
    { name: 'code', type: 'string' },
    { name: 'material_group_id', type: 'selectAutoComplete', model: 'material-group', placeholder: 'Material group' },
    { name: 'measurement_unit_id', type: 'selectAutoComplete', model: 'unit-measurement', placeholder: 'Unit Measurement' },
  ];

  return (
    <CrudEdit
      model={'material'}
      fields={fields}
      register={register}
      handleSubmit={handleSubmit}
      control={control}
      setFormValue={setFormValue}
      messageSuccess={'Material successfully updated!'}
      title={'Edit material'}
      getValues={getValues}
    />
  );
}